import { render } from "./waitlist.vue?vue&type=template&id=606ee3e2"
import script from "./waitlist.vue?vue&type=script&lang=js"
export * from "./waitlist.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__